module.exports = __webpack_public_path__ + "img/retro.3e64a4ed.png";